import SvgText from "./SvgText";
import getSvgBorderLineMap from "./getSvgBorderLineMap";
import SvgBandAnnotation from './SvgBandAnnotation';
import SvgImage from './SvgImage';
import SvgExpansion from './SvgExpansion';

import { getTextWidth } from './PositionalLayout';

export default function SvgRendering({
  div,
  gridOrigin,
  value,state,cell,
  imageUrlMap, 
  figurePanel, 
  exportId,
  onClick,
  download,
}){

  

  let {x,y,width,height} = div.getBoundingClientRect();
  let relX = x - gridOrigin[0];
  let rectRelY = y - gridOrigin[1];

  if( !value ){ return null };

  let rawVal = value.value;

  //can't return null here just because 
  // value.value is falsy
  //because there may be borders
  //on the empty cell
  

  let val = typeof(rawVal)==='string' ? rawVal : "OBJ";

  let valueIsText = typeof(value.value) === 'string';

  let text = valueIsText && <SvgText {...{
    gridOrigin,

    div,
    cell,
    value,

    relX,
    rectRelY,
    width,
    height
  }}/>
  

  //Take the id of each char
  //We see where the lines are
  //We take the position of the first character as the starting point
  //We string all the characters together
  //If they are in the same line, then they are a line and we only want to keep that
  //Otherwise, they're different lines and we need to ust keep them separately. 

  let linesStartX = {}
  let textLines = {};

  /*
   *<text textAnchor={"middle"} style={{fill:'black',textAlign:'center'}} width={width} height={height} x={relX+0.5*width} y={relY+0.5*height} dominantBaseline="middle">{val}</text>*/



  let borders = [];
  if( value.style ){
    let borderStyles = Object.keys(value.style).filter(key => key.includes('border'));

    let borderTopXOffset = (width * (100 - (value.style.topBorderWidth||100)) / 200 );
    let borderBottomXOffset = (width * (100 - (value.style.bottomBorderWidth||100)) / 200 );
    let borderLeftYOffset = (height * (100 - (value.style.leftBorderHeight||100)) / 200 );
    let borderRightYOffset = (height * (100 - (value.style.rightBorderHeight||100)) / 200 );

    let borderTopX1 = relX + borderTopXOffset - 0.5;
    let borderTopX2 = relX + width - borderTopXOffset + 1;
    let topBracketHeight = value.style.topBracketHeight || 0;

    let borderBottomX1 = relX + borderBottomXOffset - 0.5;
    let borderBottomX2 = relX + width - borderBottomXOffset + 1;
    let bottomBracketHeight = value.style.bottomBracketHeight || 0;

    let rightBracketWidth = value.style.rightBracketWidth || 0;
    let leftBracketWidth = value.style.leftBracketWidth || 0;

    let missingBorder = (value.style.borderThickness || 1)/2;


    let borderLineMap = getSvgBorderLineMap({

      borderThickness:value?.style?.borderThickness||0,

      width,
      height,


      borderTopX1,
      borderTopX2,

      borderBottomX1,
      borderBottomX2,

      topBracketHeight,
      bottomBracketHeight,

      relX,
      rectRelY,

      borderLeftYOffset,
      borderRightYOffset,

      leftBracketWidth,
      rightBracketWidth,

      missingBorder,
    })

    if( !borderLineMap ){
      debugger;
    }
    


    for(let key in borderLineMap){
      let line = borderLineMap[key];
      for(let coordKey in line){
        let num = line[coordKey]
        if( Number(num) === num ){
          //line[coordKey] = Math.round(line[coordKey]);
        }
      }
    }


    borderStyles.forEach( styleKey => {
      if( styleKey === 'borderThickness' || styleKey.includes('Dashed') ){
        return; 
      }

      let givenStyle = value.style[styleKey];
      let borderLineIsNotSet = !givenStyle;
      if( borderLineIsNotSet ){
        return;
      }

      let stroke;
      if( value.style ){ 
        stroke = value.style.borderColor || "black";
      }
    
      if( !givenStyle.split ){
        debugger;
      }

      let spl = givenStyle?.split(' ') || givenStyle;
      
      

      let strokeWidth = spl[0];// || value.style.borderThickness;
      let resolvedStroke = stroke || spl[2];
      let style={
        stroke:resolvedStroke,

        ...(
      value.style[ styleKey+"Dashed" ] ? { strokeDasharray:"10,10" } : {}
        ),
        //'rgb('+Array(3).fill(null).map(x => Math.round(Math.random()*255)).join(',')+')',

        //stroke:'rgb('+Array(3).fill(null).map(x => Math.round(Math.random()*255)).join(',')+')',

        strokeWidth:value.style.borderThickness||1}
      let lineArgs = {
        ...borderLineMap?.[styleKey],
        style,
        

        //strokeWidth:99,//(value.style.borderThickness||1)
      }

      borders.push(<line cell={cell} {...lineArgs}/>);
    })

    
    //let strokeWidth = value.style.borderThickness || 1;
    if( value.style.borderThickness ){
      debugger;
    }

    const makeLine = pointMap => <line {...{
      cell,
      stroke:'black',
      strokeWidth:1,
      ...pointMap,
      shapeRendering:"crispEdges",
        

    }}/>

      borders.push(...[
        ...(value.style.borderTop ? [
        makeLine(borderLineMap.borderTopLeftBracket),
        makeLine(borderLineMap.borderTopRightBracket),
        ] : [] ),


        ...(value.style.borderBottom ? [
          makeLine(borderLineMap.borderBottomLeftBracket),
          makeLine(borderLineMap.borderBottomRightBracket),
        ] : [] ),


        ...(value.style.borderRight ? [

        makeLine(borderLineMap.borderRightBottomBracket),
        makeLine(borderLineMap.borderRightTopBracket),
        ] : [] ),


        ...(value.style.borderLeft ? [
        makeLine(borderLineMap.borderLeftBottomBracket),
        makeLine(borderLineMap.borderLeftTopBracket),
        ] : [] ),

      ]);


  }



  let image;
  let bandAnnotation;

  let relBounds = {
    x:relX,
    y:rectRelY,
    width,
    height
  }



  let imageTypes = ['crop','image'];
  if( imageTypes.includes(value.value.valueType) && value.value.expandable !== true ){

    image = <SvgImage 
      onClick={onClick}
      exportId={exportId}
    imageUrlMap={imageUrlMap} state={state} value={value} bounds={relBounds} div={div} download={download} />

  }else if( value.value.valueType === 'bandAnnotation' ){
    bandAnnotation = (
      <SvgBandAnnotation 
        figurePanel={figurePanel}
        cell={cell}
        state={state}
        annotation={value.value} 
        bounds={relBounds}
      />
    )

  }else if( imageTypes.includes(value.value.valueType) && value.value.expandable === true ){
    image = <SvgExpansion {...{
      div,
      gridOrigin,
      value,state,cell,imageUrlMap,figurePanel,exportId, download}}/>

  }




  let fontSize;
  if( value.style && value.style.fontSize ){
    fontSize = value.style.fontSize
  }else{
    fontSize = 12;
  }

 

  return (
    <>
      
     
      {text}
      

      
      {image}
      {bandAnnotation}

      {borders}
    </>
  )
}
